export default __webpack_public_path__ + "maps-examples-image-source-thumbnail-960-806c7d59ae3c886b929c95339f60dab8.webp";